<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="c2"></a>
</div>
<h4 class="chapnum">II.</h4>
<p class="chaptitle">A<span class="sc">RRIVAL</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_c2.vue?48bf5af5